import { render, staticRenderFns } from "./CourseSemesterSave.vue?vue&type=template&id=54e67ba9&"
import script from "./CourseSemesterSave.vue?vue&type=script&lang=js&"
export * from "./CourseSemesterSave.vue?vue&type=script&lang=js&"
import style0 from "./CourseSemesterSave.vue?vue&type=style&index=0&id=54e67ba9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports